import dynamic from 'next/dynamic'
import { useState } from 'react'
import AuthButtons from '~/src/components/AuthButtons'
import RewardsHeaderTrigger from '~/src/components/RewardsHeaderTrigger'
import { cn } from '~/src/lib/utils'

const HeaderSheetMenu = dynamic(
  () => import('~/src/components/HeaderSheetMenu'),
  {
    ssr: false,
  }
)

const UserInitials = dynamic(() => import('~/src/components/UserInitials'), {
  ssr: false,
})

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  sticky?: boolean
  transparent?: boolean
}

const LayoutFullHeader: React.FC<Props> = ({
  sticky,
  transparent,
  className,
  ...props
}) => {
  const [isSheetOpen, setIsSheetOpen] = useState(false)

  return (
    <>
      <div
        className={cn(
          'flex items-center justify-between p-4 transition-all duration-100 md:p-6',
          {
            'fixed inset-x-0 top-0 z-50': sticky,
            relative: !sticky,
            'bg-transparent': transparent,
            'dark:bg-darkest bg-white text-black dark:text-white': !transparent,
          },
          className
        )}
        {...props}
      >
        <div className='flex min-h-[40px] flex-1 items-center justify-between gap-2 md:justify-start'>
          <HeaderSheetMenu
            setIsSheetOpen={setIsSheetOpen}
            isSheetOpen={isSheetOpen}
          />
          <div className='ml-auto flex items-center gap-2'>
            <RewardsHeaderTrigger />
            <AuthButtons className='border-white/50' />
            <UserInitials />
          </div>
        </div>
      </div>
    </>
  )
}

export default LayoutFullHeader
